'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var Theme = require('../../Theme/Theme.js');
require('../../Theme/DarkTheme.js');
require('../../Theme/LightTheme.js');
var createMuiTheme = require('../../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var alertTheme = createMuiTheme(_objectSpread({}, Theme.theme, {
  palette: {
    primary: Theme.theme.palette.alert
  }
}));

exports.alertTheme = alertTheme;
